import { useEffect, useState } from "react";
import LeftSection from "../../components/baca_quran/leftsection";
import RightSection from "../../components/baca_quran/rightsection";
import { QuranApi } from "../../services/quran_api";
import Loading from "../../components/loading";

function BacaQuran() {
  const [listSurah, setListSurah] = useState([]);
  const [detailSurah, setDetailSurah] = useState({});
  const [showLeftSection, setShowLeftSection] = useState(true); // State untuk toggle
  const [loading, setLoading] = useState(true);
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    getSurah();
  }, []);

  async function getSurah() {
    await QuranApi.getSurah().then((surah) => {
      setListSurah(surah);
      setLoading(false);
    });
  }

  async function getDetailSurah(nomor) {
    setLoadingDetail(true);
    setDetailSurah({})
    await QuranApi.getDetailSurah(nomor).then((detailSurah) => {
      setDetailSurah(detailSurah);
      setLoadingDetail(false);
    });
  }

  function toggleLeftSection() {
    setShowLeftSection((prev) => !prev); // Toggle visibilitas LeftSection
  }

  return (
    <div className="flex w-full h-screen">
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Left Section */}
          {showLeftSection && (
            <LeftSection
              listSurah={listSurah}
              getDetailSurah={getDetailSurah}
            />
          )}

          {/* Right Section */}
          <RightSection
            detailSurah={detailSurah}
            toggleLeftSection={toggleLeftSection}
            loadingDetail={loadingDetail}
          />
        </>
      )}
    </div>
  );
}

export default BacaQuran;
